﻿import { LookupItem } from '../models/lookup-item';
import { CrudFunctions } from '../utilities/crud-functions';

export class CommonDataStore {
    static uoms: LookupItem[];
    
    static async getAllUoms(): Promise<any> {
        if (CommonDataStore.uoms && CommonDataStore.uoms.length > 0) {
            return CommonDataStore.uoms;
        }
        else {
            let response = CrudFunctions.getData("common/uoms")
                .then((data) => {
                    CommonDataStore.uoms = data;
                    return CommonDataStore.uoms;
                })

            return response;
        }
   }    
}